import React from 'react';
import { bool, func } from 'prop-types';
import NavbarLogo from './NavbarLogo';
import NavbarItem from './NavbarItemContainer';
import './Navbar.css';

const items = [
  {
    text: 'Buscar',
    link: 'http://www.olx.com.br/brasil',
    label: 'buscar',
  },
  {
    text: 'Ajuda',
    link: 'http://www.olx.com.br/faq.htm',
    label: 'ajuda',
  },
  {
    text: 'Meus Anúncios',
    link: 'https://www3.olx.com.br/account/userads/',
    label: 'meus_anuncios',
  },
  {
    text: 'Lojas',
    link: 'http://www.olx.com.br/lojas',
    label: 'lojas',
  },
];

const NavbarItems = () => (
  items.map(item => (
    <NavbarItem
      key={item.text}
      className="header-list-item visible-only-on-large"
      classLink="header-list-item-link"
      text={item.text}
      link={item.link}
      label={item.label}
    />
  ))
);

const Navbar = ({ showItems, onMouseOver }) => (
  // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
  <header className="header" onMouseOver={onMouseOver}>
    <ul className="header-list">
      <NavbarItem
        className="header-list-item"
        classLink="header-list-item-link"
        link="https://www.olx.com.br/"
        label="logo"
      >
        <NavbarLogo className="header-list-item-icon" />
      </NavbarItem>
      {showItems && <NavbarItems />}
    </ul>
  </header>
);

Navbar.propTypes = {
  showItems: bool,
  onMouseOver: func,
};

Navbar.defaultProps = {
  showItems: true,
  onMouseOver: () => {},
};

export default Navbar;
